import { getWindow } from "@faire/web--source/common/globals/getWindow";
import { FC, useCallback, useEffect } from "react";

interface IScrollProps {
  onScroll: ((event: Event) => void) | undefined;
}

export const PassiveScroll: FC<IScrollProps> = ({ onScroll }) => {
  const handleOnScroll = useCallback(
    (event: Event): void => {
      onScroll?.(event);
    },
    [onScroll]
  );
  useEffect(() => {
    getWindow()?.addEventListener("scroll", handleOnScroll, {
      passive: true,
    });
    return () => {
      getWindow()?.removeEventListener("scroll", handleOnScroll);
    };
  }, [handleOnScroll]);
  return null;
};
